export const catchNextClick = (e, isDisabled) => {
    if (isDisabled)
        e.preventDefault();
};
export const showThirdBullet = (abGroup, partnerSignup) => (abGroup !== null && abGroup === 'A') || (partnerSignup !== null && (partnerSignup.code === 'QBO' || partnerSignup.code === 'QBD'));
